
(() => {
  const buttons = () => Array.from(document.querySelectorAll('.medus-card__heart-button'));
  if (!buttons().length) return;

  const wishlistStorageKey = 'wish-list-products';
  const pendingWishlistKey = 'wish-list-products-pending';
  const currentUrl = window.location.pathname + window.location.search;
  const wishlistAddedClass = 'is-in-wishlist';
  const wishlistAddMessage = 'Click here to add this product in your wishlist.';
  const wishlistRemoveMessage = 'Click here to remove this product in from your wishlist.';
  const b2bOnlyMessage = 'Only B2B customers are authorized to perform this action.';
  const tooltipTimers = new WeakMap();

  const getButtonContext = (button) => ({
    customerId: String(button.dataset.customerId || '').trim(),
    loginUrl: button.dataset.loginUrl || '/account/login',
    isB2b: button.dataset.isB2b === 'true',
  });

  const readStorageArray = (key) => {
    try {
      const raw = window.localStorage.getItem(key);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  const writeStorageArray = (key, value) => {
    window.localStorage.setItem(key, JSON.stringify(value));
    if (key === wishlistStorageKey) {
      const totalCount = Array.isArray(value)
        ? value.reduce((sum, entry) => {
            const quantity = Number(entry && entry.quantity) || 1;
            return sum + quantity;
          }, 0)
        : 0;
      window.dispatchEvent(
        new CustomEvent('wishlist:updated', {
          detail: { count: totalCount },
        })
      );
    }
  };

  const getWishlistOwnerId = (wishlist) => {
    if (!wishlist.length) return '';
    return String(wishlist[0].customerId || '').trim();
  };

  const shouldResetWishlistForCustomer = (wishlist, customerId) => {
    if (!wishlist.length) return false;
    if (!customerId) return false;
    const storedCustomerId = getWishlistOwnerId(wishlist);
    if (!storedCustomerId) return false;
    return storedCustomerId !== customerId;
  };

  const ensureWishlistMatchesCustomer = (customerId) => {
    const wishlist = readStorageArray(wishlistStorageKey);
    if (shouldResetWishlistForCustomer(wishlist, customerId)) {
      writeStorageArray(wishlistStorageKey, []);
      return [];
    }
    return wishlist;
  };

  const isVariantInWishlist = (variantId, wishlist) => {
    if (!variantId) return false;
    return wishlist.some((entry) => String(entry.variantId) === String(variantId));
  };

  const hideWishlistTooltip = (button) => {
    const tooltip = button.querySelector('.medus-card__heart-tooltip');
    if (!tooltip) return;
    tooltip.classList.remove('is-visible');
  };

  const renderWishlistButtonsState = (targetButtons) => {
    (targetButtons || buttons()).forEach((button) => {
      const { customerId, isB2b } = getButtonContext(button);
      if (!customerId) {
        button.classList.remove(wishlistAddedClass);
        button.classList.remove('is-in-cart');
        hideWishlistTooltip(button);
        return;
      }

      if (!isB2b) {
        button.classList.remove(wishlistAddedClass);
        button.classList.remove('is-in-cart');
        showWishlistTooltip(button, b2bOnlyMessage);
        return;
      }

      const wishlist = ensureWishlistMatchesCustomer(customerId);
      const isAdded = isVariantInWishlist(button.dataset.variantId, wishlist);
      button.classList.toggle(wishlistAddedClass, isAdded);
      button.classList.toggle('is-in-cart', isAdded);
      if (isAdded) showWishlistTooltip(button, wishlistRemoveMessage);
      if (!isAdded) showWishlistTooltip(button, wishlistAddMessage);
    });
  };

  const showWishlistTooltip = (button, message) => {
    const tooltip = button.querySelector('.medus-card__heart-tooltip');
    if (!tooltip) return;
    tooltip.textContent = message;
    tooltip.classList.add('is-visible');

    const existingTimer = tooltipTimers.get(button);
    if (existingTimer) window.clearTimeout(existingTimer);

    const timer = window.setTimeout(() => {
      tooltip.classList.remove('is-visible');
    }, 1800);
    tooltipTimers.set(button, timer);
  };

  const toWishlistItem = (button, customerId) => ({
    customerId,
    productId: String(button.dataset.productId || ''),
    variantId: String(button.dataset.variantId || ''),
    sku: String(button.dataset.sku || ''),
    handle: button.dataset.productHandle || '',
    title: button.dataset.productTitle || '',
    url: button.dataset.productUrl || '',
    image: button.dataset.productImage || '',
    price: Number(button.dataset.productPrice || 0),
    quantity: 1,
    addedAt: new Date().toISOString(),
  });

  const addItemToWishlist = (item, customerId) => {
    if (!item.variantId) return;
    let wishlist = readStorageArray(wishlistStorageKey);

    if (shouldResetWishlistForCustomer(wishlist, customerId)) {
      wishlist = [];
    }

    const existingIndex = wishlist.findIndex((entry) => String(entry.variantId) === String(item.variantId));

    if (existingIndex >= 0) {
      const existing = wishlist[existingIndex];
      wishlist[existingIndex] = {
        ...existing,
        ...item,
        quantity: Number(item.quantity || existing.quantity) || 1,
      };
    } else {
      wishlist.push(item);
    }

    writeStorageArray(wishlistStorageKey, wishlist);
  };

  const removeItemFromWishlist = (variantId, customerId) => {
    if (!variantId) return;
    let wishlist = readStorageArray(wishlistStorageKey);
    if (shouldResetWishlistForCustomer(wishlist, customerId)) {
      wishlist = [];
    }
    const next = wishlist.filter((entry) => String(entry.variantId) !== String(variantId));
    writeStorageArray(wishlistStorageKey, next);
  };

  const savePendingWishlistItem = (item) => {
    if (!item.variantId) return;
    const pending = readStorageArray(pendingWishlistKey);
    const existingIndex = pending.findIndex((entry) => String(entry.variantId) === String(item.variantId));

    if (existingIndex >= 0) {
      pending[existingIndex] = { ...pending[existingIndex], ...item };
    } else {
      pending.push(item);
    }

    writeStorageArray(pendingWishlistKey, pending);
  };

  const consumePendingWishlist = (customerId) => {
    if (!customerId) return;
    const pending = readStorageArray(pendingWishlistKey);
    if (!pending.length) return;

    pending.forEach((item) => {
      addItemToWishlist({ ...item, customerId }, customerId);
    });

    window.localStorage.removeItem(pendingWishlistKey);
  };

  // Cursor/infinite-scroll pagination injects new cards via importNode, whose
  // inline scripts never run. Watch the grid and apply wishlist state (tooltip
  // text + classes) to any freshly added heart buttons.
  const observeNewCards = () => {
    const grid = document.querySelector('#product-grid');
    if (!grid || !('MutationObserver' in window)) return;

    const observer = new MutationObserver((mutations) => {
      const newButtons = [];
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.medus-card__heart-button')) {
            newButtons.push(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('.medus-card__heart-button').forEach((btn) => newButtons.push(btn));
          }
        });
      });
      if (newButtons.length) renderWishlistButtonsState(newButtons);
    });

    observer.observe(grid, { childList: true });
  };

  const initialize = () => {
    const firstButton = buttons().find((button) => button.dataset.customerId);
    const customerId = firstButton ? String(firstButton.dataset.customerId || '').trim() : '';
    ensureWishlistMatchesCustomer(customerId);
    consumePendingWishlist(customerId);
    renderWishlistButtonsState();
    observeNewCards();
  };

  document.querySelectorAll('[data-qty-wrap]').forEach((wrap) => {
    const input = wrap.querySelector('.na-qty__input');
    const minus = wrap.querySelector('[data-qty-change="decrease"]');
    const plus = wrap.querySelector('[data-qty-change="increase"]');

    if (!input || input.disabled) return;

    const sync = () => {
      const min = Number(input.min || 1);
      const max = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
      let value = Number(input.value || min);

      if (value < min) value = min;
      if (value > max) value = max;
      input.value = value;

      minus.disabled = value <= min;
      plus.disabled = value >= max;
    };

    minus.addEventListener('click', () => {
      input.stepDown();
      sync();
    });

    plus.addEventListener('click', () => {
      input.stepUp();
      sync();
    });

    input.addEventListener('input', sync);
    sync();
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.medus-card__heart-button');
    if (!button) return;
    event.preventDefault();

    const { customerId, loginUrl, isB2b } = getButtonContext(button);
    if (!customerId) {
      button.classList.remove(wishlistAddedClass);
      hideWishlistTooltip(button);
      savePendingWishlistItem(toWishlistItem(button, customerId));
      window.location.href = `${loginUrl}?return_url=${encodeURIComponent(currentUrl)}`;
      return;
    }

    if (!isB2b) {
      showWishlistTooltip(button, b2bOnlyMessage);
      return;
    }

    const wishlist = ensureWishlistMatchesCustomer(customerId);
    const isAlreadyAdded = isVariantInWishlist(button.dataset.variantId, wishlist);

    if (isAlreadyAdded) {
      removeItemFromWishlist(button.dataset.variantId, customerId);
      button.classList.remove(wishlistAddedClass);
      button.classList.remove('is-in-cart');
      showWishlistTooltip(button, wishlistAddMessage);
      return;
    }

    const item = toWishlistItem(button, customerId);
    addItemToWishlist(item, customerId);
    button.classList.add(wishlistAddedClass);
    button.classList.add('is-in-cart');
    showWishlistTooltip(button, wishlistRemoveMessage);
  });

  initialize();
})();
